module.exports = __webpack_public_path__ + "static/media/apps-chrome.cf5c3881.jpeg";